export default "__VITE_ASSET__BGw9WzYB__"